
export const mutations = {
    STORE_USER_PROFILE(state, profile) {
        state.userprofile = profile
    },
    STORE_USER_ROLE(state, role) {
        state.usersrole = role
    }
}
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/userprofile/mutations.js